module.exports = __webpack_public_path__ + "static/media/gear-green.1a9ab4b5.svg";